import * as React from 'react';
import { useEffect, useState } from 'react';
import { ICartProduct } from 'components/Cart/Interfaces/ICartProduct';
import Product from 'components/Cart/Product/Product';
import classNames from 'classnames';
import { CartType } from 'components/Cart/Enum/CartType';
import { IInbankRentalProductLabels } from 'components/Cart/CheckoutCart';
import { IInbankRentalLabels } from 'components/Cart/InbankRental/InbankRentalSidebar';
import Callout from 'vkid-ui/lib/Components/Callout';
import BuyBackProduct from 'components/Cart/Product/BuyBackProduct';
import { IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';
import { useRequest } from 'redux-query-react';
import getBuyBackProductsRequest from 'components/BuyBack/requests/getBuyBackProductsRequest';
import { useSelector } from 'react-redux';

export interface IInbankRentalProductsProps {
    products: ICartProduct[];
    quoteId?: string;
    emptyMessage?: string;
    tabActive: boolean;
    inbankRentalProductLabels?: IInbankRentalProductLabels;
    inbankRentalLabels?: IInbankRentalLabels;
    productRemovedLabel: string;
    productTableLabels: {
        productImageLabel: string;
        productInfoLabel: string;
        productTotalsLabel: string;
    };
}

const mapStateToProps = (state) => {
    return {
        savedBuyBackProducts: state.entities?.buyBackProducts?.devices as IBuyBackProduct[],
    };
};

const InbankRentalProducts = (props: IInbankRentalProductsProps) => {
    const {
        products,
        quoteId,
        emptyMessage,
        tabActive,
        inbankRentalProductLabels,
        inbankRentalLabels,
        productRemovedLabel,
        productTableLabels,
    } = props;
    const [error, setError] = useState<string>();
    const [message, setMessage] = useState<string>();

    const [buyBackProducts, setBuyBackProducts] = useState<IBuyBackProduct[]>([]);
    const [{}] = useRequest(getBuyBackProductsRequest());
    const { savedBuyBackProducts } = useSelector(mapStateToProps);

    useEffect(() => {
        if (!savedBuyBackProducts) {
            return;
        }
        setBuyBackProducts(savedBuyBackProducts);
    }, [savedBuyBackProducts]);

    if (!products || !quoteId) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            <div className={classNames('layout-cart__main', { hidden: !tabActive })}>
                {error && (
                    <Callout intent="danger" isAlert ariaLive="assertive">
                        {error}
                    </Callout>
                )}

                {message && (
                    <Callout intent="success" isAlert ariaLive="assertive">
                        {message}
                    </Callout>
                )}

                {emptyMessage && <div className="cart-callout">{emptyMessage}</div>}
                <table className={'cart-table'}>
                    <thead>
                        <tr>
                            <th>{productTableLabels.productImageLabel}</th>
                            <th>{productTableLabels.productInfoLabel}</th>
                            <th>{productTableLabels.productTotalsLabel}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((product, key) => (
                            <Product
                                inbankRentalProductLabels={inbankRentalProductLabels}
                                product={product}
                                key={key}
                                quoteId={quoteId}
                                cartType={CartType.INBANK_RENTAL_CART}
                                setError={setError}
                                setMessage={setMessage}
                                isInbankRental={true}
                                inbankRentalLabels={inbankRentalLabels}
                                productRemovedLabel={productRemovedLabel}
                            />
                        ))}
                        {savedBuyBackProducts && savedBuyBackProducts.length > 0 && (
                            <BuyBackProduct
                                buyBackProducts={buyBackProducts}
                                setBuyBackProducts={setBuyBackProducts}
                                resetBuyBackProducts={() => {
                                    if (savedBuyBackProducts) {
                                        setBuyBackProducts(savedBuyBackProducts);
                                    }
                                }}
                            />
                        )}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};

export default InbankRentalProducts;
